/* AMTENDENCY — cursor "+" sobre as fotos do produto.

   Medido na referência: um bloco de 110×110 que segue o ponteiro, escondido
   (opacity 0 / visibility hidden) fora da galeria e visível ao entrar nela,
   com um círculo de 60px por dentro. O sinal de "+" indica que a foto amplia.

   Só no computador, e só quando há ponteiro fino. */
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (!document.body.classList.contains('template-product')) return;

  var cursor = null;
  var x = 0;
  var y = 0;
  var raf = null;

  function cria() {
    cursor = document.createElement('div');
    cursor.className = 'am-cursor-zoom';
    cursor.setAttribute('aria-hidden', 'true');
    cursor.innerHTML = '<span class="am-cursor-zoom__circulo"></span>';
    document.body.appendChild(cursor);
  }

  function pinta() {
    raf = null;
    cursor.style.setProperty('--am-zoom-x', x);
    cursor.style.setProperty('--am-zoom-y', y);
  }

  document.addEventListener(
    'mousemove',
    function (e) {
      var dentro = e.target.closest && e.target.closest('.product__media-wrapper .product__media-item');
      if (!cursor) {
        if (!dentro) return;
        cria();
      }
      // o botão "Mostrar mais" flutua sobre a galeria: ali vale o cursor normal
      var noBotao = e.target.closest && e.target.closest('.am-galeria-mais');
      document.body.classList.toggle('am-zoom-ativo', !!dentro && !noBotao);
      x = e.clientX;
      y = e.clientY;
      if (raf) return;
      raf = requestAnimationFrame(pinta);
    },
    { passive: true }
  );

  document.addEventListener('mouseleave', function () {
    document.body.classList.remove('am-zoom-ativo');
  });
})();
